<template>
  <div class="poll-results">
    <h4>{{ sharedResults.question }}</h4>

    <ul class="list-votes">
      <li v-for="(vote, index) in votes" :key="index">
        <div class="progress">
          <div class="progress-bar" role="progressbar"
            :aria-valuenow="vote.percentage" aria-valuemin="0" aria-valuemax="100"
            :style="{width: `${vote.percentage}%`}"></div>
          <span>{{ vote.answer }}</span><span>{{ vote.percentage }}%</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
const PollResults = {
  name: 'PollResults',

  computed: {
    sharedResults() {
      return this.$store.state.g2wSession.polls.sharedResults;
    },

    votes() {
      return this.sharedResults.answers.map((answer, index) => {
        const numVotes = this.sharedResults.numVotes[index];
        let percentage = 0;
        if (this.sharedResults.totalPollParticipants) { // don't divide by 0
          percentage = (numVotes / this.sharedResults.totalPollParticipants) * 100;
        }

        return {
          answer,
          numVotes,
          percentage: Math.round(percentage)
        };
      });
    }
  }
};

export default PollResults;
</script>

<style lang="sass">
  .poll-results
    .list-votes
      list-style: none
      padding-left: 0

      li
        margin: 20px 0

        .progress
          min-height: 3rem
          position: relative
          display: flex
          justify-content: space-between
          align-items: center
          padding: 0 5px

          span
            z-index: 1

          .progress-bar
            position: absolute
            left: 0
            height: 100%
            background-color: lightsteelblue

</style>
